export default "__VITE_ASSET__CGHiq55I__"